// Fonts
import { lalezarFontFamily, alexBrushFontFamily } from '@/styles/fonts';

// Constants
import { TYPING_TEXT_ANIMATION } from '../../constants';

// Components
import { TypingText } from '@/components/common/animations/TypingText';

// Theme
import { employeeYearInReviewTheme } from '@/components/EmployeeYearInReview/theme';

interface TypingTextAnimationProps {
  /** Normal text; \n for line breaks, highlight inserts after first line */
  normalText: string;
  /** Highlight text, inline after first line */
  highlightText: string;
}

export const TypingTextAnimation = ({
  normalText,
  highlightText,
}: TypingTextAnimationProps) => {
  // Split normal text into lines
  const [firstLine = '', ...restLines] = normalText.split('\n');
  const afterHighlight = restLines.join('\n');

  // Sequential timing: each segment starts after the previous finishes
  const highlightStart =
    TYPING_TEXT_ANIMATION.startFrame +
    Math.ceil(firstLine.length / TYPING_TEXT_ANIMATION.charsPerFrame);
  const afterStart =
    highlightStart +
    Math.ceil(
      highlightText.length / TYPING_TEXT_ANIMATION.highlight.charsPerFrame,
    );

  const { colors } = employeeYearInReviewTheme;

  return (
    <div
      className={`absolute ${colors.textSecondary}`}
      style={{
        left: TYPING_TEXT_ANIMATION.left,
        top: TYPING_TEXT_ANIMATION.top,
        maxWidth: TYPING_TEXT_ANIMATION.maxWidth,
        transform: `rotate(${TYPING_TEXT_ANIMATION.rotation}deg)`,
        fontFamily: lalezarFontFamily,
        fontSize: TYPING_TEXT_ANIMATION.normal.fontSize,
        lineHeight: `${TYPING_TEXT_ANIMATION.normal.lineHeight}px`,
      }}
    >
      {/* First line: "Training packed its bags and went on " */}
      <TypingText
        text={firstLine}
        startFrame={TYPING_TEXT_ANIMATION.startFrame}
        charsPerFrame={TYPING_TEXT_ANIMATION.charsPerFrame}
        showCursor={false}
        stableLayout
      />

      {/* Highlight: "holiday." inline after first line */}
      <TypingText
        text={highlightText}
        startFrame={highlightStart}
        charsPerFrame={TYPING_TEXT_ANIMATION.highlight.charsPerFrame}
        showCursor={false}
        stableLayout
        className={colors.textPrimary}
        style={{
          fontFamily: alexBrushFontFamily,
          fontSize: TYPING_TEXT_ANIMATION.highlight.fontSize,
          lineHeight: `${TYPING_TEXT_ANIMATION.highlight.lineHeight}px`,
          marginLeft: TYPING_TEXT_ANIMATION.highlight.marginLeft,
        }}
      />

      {/* Remaining lines: "Back soon!" */}
      {afterHighlight && (
        <div>
          <TypingText
            text={afterHighlight}
            startFrame={afterStart}
            charsPerFrame={TYPING_TEXT_ANIMATION.charsPerFrame}
            stableLayout
          />
        </div>
      )}
    </div>
  );
};
